import LoginForm from "~/components/pages/auth/LoginForm";
import { validateCredentials } from "~/validation/validation.auth.server";
import { login, redirectIfUserSessionAvailable } from "~/data/auth.server";
import type { LoaderFunctionArgs } from "react-router";

export const meta = () => {
  return [{ title: "Hupu: Login" }];
};

export async function loader({ request }: LoaderFunctionArgs) {
  await redirectIfUserSessionAvailable(request);
  return null;
}

export async function action({ request }: LoaderFunctionArgs) {
  const formData = await request.formData();
  const credentials: any = Object.fromEntries(formData);

  try {
    validateCredentials(credentials);
  } catch (error) {
    return error;
  }

  //await devOutputCredentialsToConsole(credentials)

  try {
    return await login(credentials);
  } catch (error: any) {
    //console.log("catch (error) in login route");
    //console.log("error.status:" + error.status);

    //if (error.status === 422) {
    return { credentials: error.message };
    //}
  }
}

export default function LoginRoute() {
  return (
    <>
      <LoginForm />
    </>
  );
}
